import "core-js/modules/es6.object.keys.js";
export function injectProp(target, propName, get, set) {
  Object.defineProperty(target, propName, {
    get: get,
    set: set,
    enumerable: true
  });
  return target;
}
export function injectMultipleProps(target, props) {
  Object.keys(props).forEach(function (key) {
    injectProp(target, key, props[key]);
  });
  return target;
}